import React from 'react';
import { Link } from 'wouter';
import { routes } from '../../modules/routes';

import styles from './footer-brand.module.scss';

export function FooterBrand() {
    return (
        <div className={styles.footer_brand}>
            <Link href={routes.home.path} title="Snazzy Maps">
                <span>Snazzy Maps</span>
                <span></span>
            </Link>
        </div>
    );
}
